import { IAppState } from '@mnz-store/reducers/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getAppState = createFeatureSelector<IAppState>('app');

export const getLatestError = createSelector(
  getAppState,
  ({ messages }) => {
    return Array(...messages)
      .filter(({ error }) => error != null)
      .pop();
  }
);

export const getLatestMessage = createSelector(
  getAppState,
  ({ messages }) => {
    return Array(...messages)
      .filter(({ error }) => error == null)
      .pop();
  }
);

export const getLatestNotifications = createSelector(
  getAppState,
  ({ messages }) => {
    return Array(...messages)
  }
);
